'use strict';
import isUndefined from 'lodash/isUndefined';
import noop from 'lodash/noop';
import {isCordovaBuild} from '../../config/constants';


PersistentUploaderServiceDecorator.$inject = [
  '$provide',
];

// fails to reset from uploading to pending on FileTransferError
export function PersistentUploaderServiceDecorator($provide) {
  $provide.decorator('PersistentUploaderService', [
    '$delegate',
    '$log',
    '$window',
    'DeviceServices',
    'LocalFileDataService',
    'UPLOAD_STATUS',
    decorateService]);

  function decorateService($delegate, $log, $window, DeviceServices, LocalFileDataService, UPLOAD_STATUS) {
    let webRemoveFile = null;
    let webUpload = null;

    if (isCordovaBuild()) {
      //modify functionality to handle native device environment
      // store originals
      webRemoveFile = $delegate.removeFile;
      webUpload = $delegate.upload;

      $delegate.removeFile = cordovaRemoveFile;
      $delegate.upload = cordovaUpload;
      $delegate.cancelUpload = cancelUpload;
      $delegate.tryUpload = tryUpload;
      $delegate.tryUploads = tryUploads;
      $delegate.$$retrieveFile = $$retrieveFile;
    } // else, web environment, do nothing

    return $delegate;

    function cordovaRemoveFile(key) {
      var fileData = $delegate.getFileData(key);
      if (fileData && !isUndefined(fileData.key)) {
        try {
          _removeFile(fileData).catch(function __onRemoveError(e) {
            console.warn('Failed to cleanup local file upload ' + fileData.key);
            console.error(e);
          });
        } catch (e) {
          console.warn('Failed to cleanup local file upload ' + fileData.key);
          console.error(e);
        }
        //LocalFileDataService.addFile(fileData);
      } else {
        console.warn('PersistentUploaderService._removeFileFromStorage: unable to find file for key ' + key);
      }

      webRemoveFile.call($delegate, key);
    }

    function cancelUpload(key) {
      var fileData = $delegate.getFileData(key);

      if (fileData.uploadStatus !== UPLOAD_STATUS.UPLOADING) {
        cordovaRemoveFile(key);
      }
    }

    function cordovaUpload(key) {
      const fileData = $delegate.getFileData(key);
      if (!fileData) return Promise.reject('not found');

      if (!DeviceServices.isHighSpeed()) {
        $log.debug('PU.tryUploads: offline or low speed connection, cannot upload right now');
        return Promise.reject('offline');
      }

      if (!$delegate.getFile(key)) {
        return $$retrieveFile(key, fileData)
          .then(() => webUpload.call($delegate, key));
      } else {
        return webUpload.call($delegate, key);
      }
    }

    function $$retrieveFile(key, fileData) {
      return _retrieveFile(fileData).then(file => {
        $delegate.$$reloadFile(key, file);
        return file;
      });
    }

    function tryUpload(key) {
      const fileData = $delegate.getFileData(key);

      if (fileData && fileData.uploadStatus === UPLOAD_STATUS.PENDING) {
        return cordovaUpload(key);
      } else {
        return $delegate.getUploadPromise(key);
      }
    }

    function tryUploads() {
      // TODO: test network connection
      return $delegate.getAll().reduce(
        (promise, fileData) => promise.then(() => $delegate.tryUpload(fileData.key).catch(noop)),
        Promise.resolve(null)
      );
    }


    function _retrieveFile(fileData) {
      var deferred = Promise.defer();

      try {
        //resolveLocalFileSystemURI - recommended bu untested
        //resolveLocalFileSystemURL - original but deprecated
        $window.resolveLocalFileSystemURL(fileData.fileUri, function (fileEntry) {
          fileEntry.file(deferred.resolve.bind(deferred));
        }, deferred.reject.bind(deferred));
      } catch (error) {
        deferred.reject(error);
      }

      return deferred.promise;
    }

    function _removeFile(fileData) {
      var deferred = Promise.defer();
      var resolve = deferred.resolve.bind(deferred);
      var reject = deferred.reject.bind(deferred);

      try {
        //resolveLocalFileSystemURI - recommended bu untested
        //resolveLocalFileSystemURL - original but deprecated
        $window.resolveLocalFileSystemURL(fileData.fileUri, function (fileEntry) {
          fileEntry.remove(resolve, reject)
        }, reject);
      } catch (error) {
        deferred.reject(error);
      }

      return deferred.promise;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/upload-service/PersistentUploaderServiceDecorator.js